export enum TreatmentType{
	HOLDER = 'HOLDER',
	RESPONSIBLE = 'RESPONSIBLE',
	PROJECT = 'PROJECT',
	SUB_RESPONSIBLE = 'SUB_RESPONSIBLE',
}
